<template>
  <form role="form">
    <payout-form-group>
      <div class="form-control-space">
      <payout-hint-panel :warning="true">
         {{$t('wallets_requirement')}}
      </payout-hint-panel>
      </div>
    </payout-form-group>
    <br/>

    <payout-form-group :label="$t('Номер кошелька')"
                       class="form-group__label_align_start"
                       :required="model.isRequiredAttribute('destinationAccount')"
                       :has-errors="model.errors.has('destinationAccount')">
      <filtered-input-wrapper v-model="model.values.destinationAccount"></filtered-input-wrapper>
      <payout-input-hint-block v-slot:hints :hint="model.getHint('destinationAccount')"></payout-input-hint-block>
      <error-message-block v-slot:errors attribute="destinationAccount|*" :errors="model.errors"></error-message-block>
    </payout-form-group>

    <payout-textfield-input-group :model='model' attribute='description' :label="$t('Назначение платежа')"></payout-textfield-input-group>

    <payout-input-amount-form-group :model="model"></payout-input-amount-form-group>

    <payout-estimated-destination-amount-form-group :model="model"></payout-estimated-destination-amount-form-group>

    <payout-destination-currency-conversion-notice-form-group style="margin-top: 1em;"
                                              :model="model"></payout-destination-currency-conversion-notice-form-group>

    <payout-evaluate-fee-form-group :model="model"></payout-evaluate-fee-form-group>

    <payout-toggable-hint-panel-form-group
      v-if="model.loaded"
      :heading="$t('Лимиты')"
      :link-text="$t('Информация о лимитах')">
      {{ model.options.limitsText }}
    </payout-toggable-hint-panel-form-group>

    <payout-form-notification-block :model="model"></payout-form-notification-block>

    <hr/>
    <payout-group-verification-type :model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import {Component} from "vue-property-decorator";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import PayoutHintPanel from "@/components/forms/payout/PayoutHintPanel.vue";
import {PaymentCodeEnum, PayoutWebModel} from "capitalist-shared/src/finance/payments";
import PayoutDestinationCurrencyConversionNoticeFormGroup
  from "@/components/forms/payout/crypto/PayoutDestinationCurrencyConversionNoticeFormGroup.vue";

export class QiwiMoneyPayoutModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.Qiwi

  required = [
    'amount', 'description', 'fromAccount',
    'destinationAccount',
    'verificationType'
  ]

  values = {
    fromAccount: '', amount: '', label: '',
    verificationType: '', autosplit: false, destinationAccount: ''
  }
}

@Component({
  name: "QiwiPaymentForm",
  components: {
    PayoutDestinationCurrencyConversionNoticeFormGroup,
    PayoutHintPanel,
    FilteredInputWrapper,
    PayoutGroupVerificationType,
    PayoutFormNotificationBlock,
    PayoutToggableHintPanelFormGroup,
    PayoutEvaluateFeeFormGroup,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutInputAmountFormGroup,
    PayoutTextfieldInputGroup, ErrorMessageBlock, PayoutInputHintBlock, PayoutFormGroup}
})
export default class QiwiPaymentForm extends AbstractPayoutForm {
  model = new QiwiMoneyPayoutModel();
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "wallets_requirement": "Transfers should only be made to verified wallets.",
    "Номер кошелька": "Wallet number",
    "Назначение платежа": "Description",
    "Лимиты": "Limits",
    "Информация о лимитах": "Limits",
    "limits": {
      "line1": "Minimum payment: {minamount}, maximum payment: {maxamount} or equivalent in selected currency.",
      "line2": "Month limit per 1 wallet: {maxamount} or equivalent in selected currency."
    }
  },
  "ru": {
    "wallets_requirement": "Переводы должны осуществляться только на верифицированные кошельки.",
    "limits": {
      "line1": "Минимальный разовый платеж: {minamount}, максимальный: {maxamount} или эквивалент в выбранной валюте.",
      "line2": "Максимальная сумма переводов на 1 кошелек: {maxamount} в месяц или эквивалент в выбранной валюте."
    }}
}
</i18n>
